'use client';

import { usePathname } from 'next/navigation';

import {
    Alignable,
    Box,
    BoxContent,
    Button,
    ButtonVariant,
    Column,
    Columns,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

import { serverSignIn } from '@actions/get-session';

import { Big } from '@components/big';

import { sendTracking } from '@helpers/tracking';

import { Container } from './container';

export function LoginPrompt() {
    const pathName = usePathname();

    const onLogin = async () => {
        sendTracking(false, {
            action: 'Clic_redirection',
            name: 'Bouton_me_connecter',
            category: 'Bloc_deja_client',
        });
        await serverSignIn(pathName);
    };

    return (
        <Container>
            <Box className='w-fit'>
                <BoxContent>
                    <Columns verticalAlign={Alignable.ALIGNED_CENTER}>
                        <Column>
                            <Text
                                level={TextLevels.ONE}
                                typo={[TypographyAlign.TEXT_CENTERED, TypographyBold.TEXT_WEIGHT_SEMIBOLD]}
                                marginless
                            >
                                Déjà client&nbsp;?
                            </Text>
                            <Text
                                level={TextLevels.ONE}
                                typo={[TypographyAlign.TEXT_CENTERED, TypographyBold.TEXT_WEIGHT_SEMIBOLD]}
                                marginless
                            >
                                On vous montre vos <Big /> économies&nbsp;!
                            </Text>
                        </Column>
                        <Column narrow>
                            <Button
                                data-cy='incentive-block-disconnected-button'
                                onClick={onLogin}
                                type='button'
                                variant={ButtonVariant.PRIMARY}
                            >
                                Me connecter
                            </Button>
                        </Column>
                    </Columns>
                </BoxContent>
            </Box>
        </Container>
    );
}
